<template>
  <div>
    <section id="loader" class="pa-5 text-center" v-if="questionnaire.loading">
      <Loader />
    </section>
    <WidgetForm
      v-else-if="questionnaire.item"
      :data="questionnaire.item"
      class="pa-5 mx-auto"
      style="max-width: 600px;"
      @onSuccess="onWidgetFormSuccess"
      @onError="onWidgetFormError"
      ref="myForm"
    >
      <TermsAndConditions
        @accepted="termsAccepted = true"
        @declined="termsAccepted = false"
      />
      <template v-slot:actions="slotProps">
        <div class="d-flex" style="gap: 10px;">
          <Button
            color="#f0f0f0"
            v-if="!embedMode || formIsMain.isActive || (mainPath === $route.path)"
            @click="onExit"
          >
            {{ $t('basics.exit') }}
          </Button>
          <Button
            class="flex-grow-1 block"
            :color="btnPrimary.bgColor"
            :style="`color: ${btnPrimary.textColor};`"
            :loading="slotProps.sendingForm"
            :disabled="!termsAccepted || slotProps.sendingForm"
            type="submit"
          >
            {{ $t('basics.continue') }}
          </Button>
        </div>
      </template>
    </WidgetForm>
  </div>
</template>

<script>
/* eslint-disable */
import questionnaireServices from '@/services/Questionnary'
import { mapState } from 'vuex'

export default {
  components: {
    WidgetForm: () => import('@/components/elements/widget-form/Index.vue'),
    Loader: () => import('@/components/ui/Loader.vue'),
    TermsAndConditions: () => import(/* webpackPrefetch: true */ '@/components/TermsAndConditions.vue'),
    Button: () => import('@/components/ui/Button.vue'),
  },
  data() {
    return {
      formData: {},
      termsAccepted: false,
      sendingForm: false,
      countryCode: null,
    }
  },
  computed: {
    ...mapState({
      questionnaire: state => state.questionnary,
      customer: state => state.storage?.room?.customer ?? {},
      mainPath: state => state.widget.mainPath,
      embedMode: state => state.widget.embedMode
    }),
    btnPrimary () {
      const { data } = this.$organization.btnPrimaryConfig()

      return {
        bgColor: data?.btn ?? 'primary',
        textColor: data?.text ?? '#fff'
      }
    },
    formIsMain () {
      return this.$organization.formIsMain()
    }
  },
  methods: {
    onWidgetFormSuccess ({ validateEmail, sessionAnswers, formData, questionnaireCode }) {
      if (this.$organization.validationEmail() && !validateEmail) {
        this.$router.replace({
          path: '/validate-email',
          query: { nextPath: this.$route.query.nextPath ?? null }
        })
      } else if (!this.$organization.smartMode() && this.formIsMain.isActive) {
        this.$router.replace({ path: '/categories' }).catch(() => {})
      } else if (this.$organization.calendaryModule() && this.$organization.directCallModule() && this.formIsMain.isActive) {
        this.$router.replace({ path: '/attention-types' }).catch(() => {})
      } else if (this.$route.query.nextPath) {
        this.$router.replace({ path: this.$route.query.nextPath }).catch(() => {})
      } else if (this.$organization.calendaryModule()) {
        this.$router.replace({ path: '/calendar', query: { requestChannel: true } }).catch(() => {})
      } else {
        this.$router.replace({ path: '/permissions', query: { requestChannel: true } }).catch(() => {})
      }
    },
    onWidgetFormError () {
      console.log('error')
    },
    onExit () {
      try {
        if (this.$organization.hideOnFinish()) {
          this.$widget.hide()
        } else {
          this.$widget.toggle(false)
        }
      } catch (e) {
        console.log(e)
      }
    }
  },
  mounted () {
    questionnaireServices.getMainQuestionnary(1)
  }
}
</script>
